import { render } from "./CanLevel.vue?vue&type=template&id=63b70131&scoped=true"
import script from "./CanLevel.vue?vue&type=script&lang=js"
export * from "./CanLevel.vue?vue&type=script&lang=js"

import "./CanLevel.vue?vue&type=style&index=0&id=63b70131&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b70131"]])

export default __exports__